export * from './zr-angular.module';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/index.ts